<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-icon-docs-preview></ui-icon-docs-preview></p>
<h1 id="description">Description</h1>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-icon</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"analytics"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-icon</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"widgets"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-icon</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"loop"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-icon</span>&gt;</span>
</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
